import { render, staticRenderFns } from "./scend.vue?vue&type=template&id=2885c453&scoped=true"
import script from "./scend.vue?vue&type=script&lang=js"
export * from "./scend.vue?vue&type=script&lang=js"
import style0 from "./scend.vue?vue&type=style&index=0&id=2885c453&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2885c453",
  null
  
)

export default component.exports